/*
 * Created by alex@hackerbay.com on 16.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */
import * as axios from "axios";
import {getAPIUrl} from "./common";

/**
 * Debugging Switch to activate Console Logging for Stages
 * @type {boolean}
 */
const DEBUG = true;

export default async(urlIdent, phoneNumber, customerNumber) => {

    if( DEBUG ) console.log( "#########################################################################################");
    if( DEBUG ) console.log( "FNX: api/genesys.js // async // urlIdent = " + urlIdent + "// phoneNumber = " + phoneNumber + "// customerNumber = " + customerNumber );

    var apiUrl = getAPIUrl("genesys", undefined);
    if( DEBUG ) console.log( "FNX: api/genesys.js // async // API-URL = " + apiUrl );

    return await axios.post( apiUrl, {
        phoneNumber: phoneNumber,
        urlIdent: urlIdent,
        customerNumber: customerNumber
    })
}